import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Typography } from "@material-ui/core";
import SectionHeader from "components/SectionHeader";
import LinearLoader from "components/LinearLoader";
import RuleForm from "./RuleForm";
import useRuleLoader from "../hooks/useRuleLoader";
import useCheckBoxEnabled from "../hooks/useCheckBoxEnabled";

import { RuleUrlParams } from "../common/types";

export default function CreateOrEdit() {
  const { t } = useTranslation("rules");
  const { action }: RuleUrlParams = useParams();
  const { isNew, rule, isLoading } = useRuleLoader();

  const isCreate = isNew || action === "copy";

  useCheckBoxEnabled(isNew && rule.actionType === "DRAG_AND_DROP");

  return (
    <>
      <SectionHeader title={isCreate ? t("createRule") : t("editRule")}>
        <Typography>
          {t("editCreateRule", {
            action: isCreate ? t("create") : t("edit"),
          })}
        </Typography>
      </SectionHeader>
      {isLoading || !rule ? <LinearLoader /> : <RuleForm rule={rule} />}
    </>
  );
}
